import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import * as styles from "./CardType.module.scss";

const CardAsType = {
	shadow: "shadow",
	border: "border",
	shadowNew: "shadowNew",
};

const CardShape = {
	wing: "wing",
	none: "none",
};

const CardTheme = {
	wedding: "wedding",
	secondary: "secondary",
	tertiary: "tertiary",
};

const CardContext = {
	primary: "primary",
	airline: "airline",
	blog: "blog",
	brand: "brand",
	cruise: "cruise",
	flight: "flight",
	hero: "hero",
	hotel: "hotel",
	single: "single",
};

const CardOrientation = {
	horizontal: "horizontal",
	"horizontal-reverse": "horizontal-reverse",
};

const CardImageRatio = ["none", "1/1", "4/3", "16/9"];

const CardType = ({ className, type, as, theme, shape, context, children, orientation }) => {
	const Tag = `${as}`;
	const classes = cx(styles.card, {
		[className]: className,
	});
	return (
		<Tag
			className={classes}
			data-type={type}
			data-shape={shape}
			data-theme={theme}
			data-orientation={orientation}
			data-context={context}
			style={theme ? { "--_theme-color": `var(--color-${theme})` } : {}}>
			{children}
		</Tag>
	);
};

CardType.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	as: PropTypes.oneOf(["div", "section", "aside"]),
	type: PropTypes.oneOf(Object.keys(CardAsType)),
	shape: PropTypes.oneOf(Object.keys(CardShape)),
	theme: PropTypes.string,
	context: PropTypes.oneOf(Object.keys(CardContext)),
	orientation: PropTypes.oneOf(Object.keys(CardOrientation)),
	className: PropTypes.string,
};

CardType.defaultProps = {
	as: "div",
	type: undefined,
	shape: undefined,
	theme: undefined,
	context: undefined,
	orientation: undefined,
	className: undefined,
};

export default CardType;
export { CardType, CardTheme, CardAsType, CardShape, CardContext, CardOrientation, CardImageRatio };
